import React, {useState} from "react";
import {Box, Button, ListItemText, Menu, MenuItem} from "@mui/material";
import startCase from "lodash/startCase";

const styles = {
  menuButton: {
    textTransform: "none",
    letterSpacing: 0,
  },
};

const MenuSelect = ({ label: Label, onSelect, value, options, ...props }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = event => setAnchorEl(event.currentTarget);
  const closeMenu = () => setAnchorEl(null);

  const handleSelect = option => {
    onSelect(option);
    closeMenu();
  };

  return (
    <Box {...props}>
      <Button
        fullWidth
        sx={styles.menuButton}
        aria-haspopup="true"
        onClick={openMenu}
      >
        {Label ? <Label value={value} /> : value}
      </Button>

      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={closeMenu}>
        {options.map(option => (
          <MenuItem
            data-id="select-item"
            key={option}
            selected={value === option}
            onClick={() => handleSelect(option)}
          >
            <ListItemText primary={startCase(option)} />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default MenuSelect;
